export default __webpack_public_path__ + "static/media/title.f44209f1.jpg";